/**
 * Helper function to get the correct asset path for both development and production builds.
 * In production (static build), PUBLIC_URL is set to '.' so all paths become relative.
 * In development, PUBLIC_URL is typically empty or '/'.
 */
export const getAssetPath = (path: string): string => {
  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  // In production build, PUBLIC_URL is '.'
  // In dev, it's typically empty or '/'
  const publicUrl = process.env.PUBLIC_URL || '';

  return publicUrl ? `${publicUrl}/${cleanPath}` : `/${cleanPath}`;
};
